module.exports = __webpack_public_path__ + "img/18f1.aadac64f.jpg";